import { Outlet, createFileRoute } from '@tanstack/react-router'

import { AppShell } from '@/app/app-shell'
import { AuthGate } from '@/auth/auth-gate'
import { SocketProvider } from '@/socket/socket-provider'

/**
 * Pathless layout for everything behind the session. Nesting the socket inside the
 * gate means an unauthenticated visitor never opens a websocket, and the shell only
 * mounts once a profile exists -- so permission-filtered navigation renders correctly
 * on the first paint instead of flickering as permissions arrive.
 */
export const Route = createFileRoute('/_app')({
    component: AppLayout
})

function AppLayout() {
    return (
        <AuthGate>
            <SocketProvider>
                <AppShell>
                    <Outlet />
                </AppShell>
            </SocketProvider>
        </AuthGate>
    )
}
